import Vue from "vue"

let formKitPromise

function loadStylesheet(formKitOrigin) {
    return new Promise((resolve, reject) => {
        const link = document.createElement("link")
        link.rel = "stylesheet"
        link.href = `${formKitOrigin}/static/Ant/formKit.css`
        link.onload = resolve
        link.onerror = reject
        document.head.appendChild(link)
    })
}

function loadScript(formKitOrigin) {
    return new Promise((resolve, reject) => {
        const script = document.createElement("script")
        script.src = `${formKitOrigin}/static/Ant/formKit.umd.min.js`
        script.onload = () => resolve(window.formKit)
        script.onerror = reject
        document.head.appendChild(script)
    })
}

export function loadFormKit() {
    if (!formKitPromise) {
        // 与表单详情接口一致，在实际加载时读取页面环境，缺失时默认正式环境。
        const environment = window.env?._CUSTOUCH_FORM_ENV || "production"
        const formEnvironment = environment === "production" ? "cloud" : "beta"
        const formKitOrigin = `https://form.${formEnvironment}.custouch.com`
        // formKit 的 UMD 构建依赖全局 Vue；发布页和本地开发统一使用当前渲染器的 Vue 实例。
        window.Vue = Vue
        formKitPromise = Promise.all([loadStylesheet(formKitOrigin), loadScript(formKitOrigin)]).then(
            ([, formKit]) => formKit
        )
    }

    return formKitPromise
}
